import distanceCoursesRoutes from 'modules/trainingLibrary/DistanceCourses/routing/routes'

const routes = {
  root: `${distanceCoursesRoutes.root}/details`,
}

export default routes
